<template>
    <div class="columns is-multiline">
        <div v-for="note in notes" :key="note.id" class="column is-3">
            <Note :note="note" :editable="false" />
        </div>
    </div>
</template>

<script>
import Note from "./Note";
import { RepositoryFactory } from "@/services/api";

export default {
    name: "notes",
    components: {
        Note,
    },
    props: {
        roomId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            notes: [],
        };
    },
    mounted() {
        this.loadNotes();
    },
    methods: {
        async loadNotes() {
            let response = await RepositoryFactory.notes.getNotes({
                roomId: this.roomId,
            });
            this.notes = response.data;
        },
    },
};
</script>